import { backendErrorMessages, frontendErrorMessages } from '../../../Constants/errorMessages';

export const handleUnprocessableEntityAuthenticationErrors = errorsData => {
    const errorMessages = {};

    if (errorsData.errors) {
        const { errors } = errorsData;
        if (errors.mobile && errors.mobile[0] === backendErrorMessages.ALREADY_TAKEN_MOBILE)
            errorMessages.phoneNumber = frontendErrorMessages.ALREADY_TAKEN_MOBILE;
        if (errors.email) {
            switch (errors.email[0]) {
                case backendErrorMessages.ALREADY_TAKEN_EMAIL:
                    errorMessages.email = frontendErrorMessages.ALREADY_TAKEN_EMAIL;
                    break;

                case backendErrorMessages.EMAIL_NOT_FOUND:
                    errorMessages.email = frontendErrorMessages.EMAIL_NOT_FOUND;
                    break;

                default:
                    break;
            }
        }
    } else {
        const { message } = errorsData;
        if (message === backendErrorMessages.EMAIL_NOT_FOUND)
            errorMessages.invalidEmail = frontendErrorMessages.EMAIL_NOT_FOUND;
    }

    return errorMessages;
};

export const handleUnauthorizedAuthenticationErrors = error => {
    let errorMessages = {};

    if (error.message === backendErrorMessages.INVALID_CREDENTIALS)
        errorMessages.invalidCredentials = frontendErrorMessages.INVALID_CREDENTIALS;

    return errorMessages;
};



// WEBPACK FOOTER //
// ./src/BusinessLogic/Errors/AuthenticationErrors/index.js